import React from 'react'

interface TitleEditorProps {
  titleData: {
    type: string
    value?: string
  }
  onTitleChange: (newTitle: any) => void
  defaultTitle: string
  documentType: 'consignment' | 'reservation' | 'estimate' | 'salenote'
}

const TitleEditor: React.FC<TitleEditorProps> = ({ titleData, onTitleChange, defaultTitle, documentType }) => {
  const predetTitleCollection = [
    { label: `Título (Usar Predeterminado: "${defaultTitle}")` },
    { label: 'Título (Usar Personalizado)' },
  ]

  const titleIndex = titleData.type === '.' || titleData.type === 'custom' ? 1 : 0
  const isCustom = titleIndex === 1

  // Consignments never show numbers, others always do
  const showsNumber = documentType !== 'consignment'

  const handleTitleTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const index = parseInt(event.target.value)
    onTitleChange({
      type: index === 0 ? '' : '.',
      value: index === 0 ? '' : titleData.value || '',
    })
  }

  const handleCustomTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onTitleChange({
      ...titleData,
      value: event.target.value,
    })
  }

  // Generate preview
  const getPreview = () => {
    const baseTitle = isCustom && titleData.value ? titleData.value : defaultTitle

    // Just show the title text without example number
    return baseTitle
  }

  return (
    <div className="border rounded p-4 mb-4 bg-gray-50">
      <div className="mb-3">
        <h3 className="text-lg font-semibold mb-2">Configuración del Título</h3>
        {!showsNumber && (
          <p className="text-sm text-gray-600">Nota: Este tipo de documento no incluye numeración automática.</p>
        )}
      </div>

      {/* Radio buttons for default/custom */}
      <div className="mb-3">
        {predetTitleCollection.map((item, index) => (
          <div key={index} className="flex items-center mb-2">
            <input
              type="radio"
              id={`title-${index}`}
              name="title-type"
              value={index}
              checked={titleIndex === index}
              onChange={handleTitleTypeChange}
              className="mr-2"
            />
            <label htmlFor={`title-${index}`} className="cursor-pointer">
              {item.label}
            </label>
          </div>
        ))}
      </div>

      {/* Custom title input */}
      {isCustom && (
        <div className="mb-3">
          <label htmlFor="custom-title-input" className="block text-sm font-medium mb-1">
            Texto del título personalizado:
          </label>
          <input
            id="custom-title-input"
            type="text"
            value={titleData.value || ''}
            onChange={handleCustomTitleChange}
            placeholder="Ej: Factura, Documento Comercial, etc."
            className="w-full p-2 border border-gray-300 rounded"
            maxLength={100}
          />
        </div>
      )}

      {/* Preview */}
      <div className="mt-3 p-3 bg-white border border-gray-300 rounded">
        <div className="text-sm font-medium text-gray-600 mb-1">Vista previa:</div>
        <div className="text-xl font-semibold text-gray-800">{getPreview()}</div>
        {showsNumber && (
          <div className="text-xs text-gray-500 mt-1">
            La numeración se asigna automáticamente al crear el documento
          </div>
        )}
      </div>
    </div>
  )
}

export default TitleEditor
